import { render, staticRenderFns } from "./ClearFilters.vue?vue&type=template&id=06d0e16a&scoped=true&"
import script from "./ClearFilters.vue?vue&type=script&lang=js&"
export * from "./ClearFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClearFilters.vue?vue&type=style&index=0&id=06d0e16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0e16a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
